import { MAP_TOOL, LAYER_IDS, PANEL, INTERACTION, MEASURE_TOOLS } from '@tmapy/config';
import { actionSetInteraction } from '@tmapy/mapcore';
import { actionSetMapTool, actionSetPanel } from '@tmapy/ui-manager';
const MEASURE_LINE_PAYLOAD = {
    type: INTERACTION.DRAW,
    layerId: LAYER_IDS.MEASURE,
    style: 'MEASURE:line',
    drawGeometryType: 'LineString',
};
const MEASURE_POLYGON_PAYLOAD = {
    type: INTERACTION.DRAW,
    layerId: LAYER_IDS.MEASURE,
    style: 'MEASURE:polygon',
    drawGeometryType: 'Polygon',
};
export const actionActivateMeasure = () => (dispatch) => {
    dispatch(actionSetMeasureLine());
    dispatch(actionSetPanel(PANEL.MEASURE));
};
export const actionDeactivateMeasure = () => (dispatch, getState) => {
    const state = getState();
    const activeMapTool = state.uiManager.activeMapTool;
    if (MEASURE_TOOLS.includes(activeMapTool)) {
        dispatch(actionSetMapTool(MAP_TOOL.NONE));
        dispatch(actionSetInteraction({ type: INTERACTION.NONE }));
    }
    dispatch(actionSetPanel(PANEL.NONE));
};
export const actionSetMeasureLine = () => (dispatch) => {
    dispatch(actionSetMapTool(MAP_TOOL.MEASURE_LINE));
    dispatch(actionSetInteraction(MEASURE_LINE_PAYLOAD));
};
export const actionSetMeasurePolygon = () => (dispatch) => {
    dispatch(actionSetMapTool(MAP_TOOL.MEASURE_POLYGON));
    dispatch(actionSetInteraction(MEASURE_POLYGON_PAYLOAD));
};
//# sourceMappingURL=actions.js.map